import React, { useState, useEffect, useRef } from 'react'
import { Link, useNavigate } from "react-router-dom";
import { apiService } from '../../constants/ApiService';
import Client from './Client';
import { Helmet } from 'react-helmet';

const TestimonialsPerPage = 5
let arrayForHoldingTestimonials = []

const About = ({ companyDetail }) => {

    const [blogTable, setBlogTable] = useState([]);



    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState(5);


    const getBlogData = async (page = 1, limit = 10, search = "") => {
        try {
            let config = {
                headers: {
                    'Content-Type': 'application/json', // Important for file upload//s
                    'accept': 'application/json'
                }
            };

            const response = await apiService.get(`/api/BlogMaster/allblog?pageNo=${page}&limit=${limit}&searchKey=${search}`, config)
            if (response.response && response.response.data.errors) {
                console.log(response.response?.data?.errors)
            }

            if (response.status === true) {
                console.log(response.blogMasterData)
                setBlogTable(response.blogMasterData)
                // console.log(response.message);
            }
            else {
                console.log(response.message);
            }
        } catch (error) {
            console.log(error)
            alert('SomeThing went wrong!!');
        }
    };

    useEffect(() => {
        getBlogData();
    }, []);

    const handleLoadMore = () => {
        setPage(prevPage => prevPage + 5);
    };





    // useEffect(() => {

    //   }, []);

    return (
        <>
            <Helmet>
                <title>{companyDetail.about_us_meta_title}</title>
                <meta name="description" content={`${companyDetail.about_us_meta_desc} Powered by Shivkms`} />                
                <meta name="keywords" content={`${companyDetail?.about_us_meta_keyword ? companyDetail.about_us_meta_keyword + ', ' : '' }Shivkms, Shiv Kirpa Multi Solution`}/>
                <meta property="og:title" content={companyDetail.about_us_meta_title} />
                <meta property="og:description" content={companyDetail.about_us_meta_desc} />
                <meta property="og:image" content={`${window.location.origin}/assets/images/logo/Valorelle_Logo.png`} />
                <meta property="og:type" content="website" />
                <meta property="og:url" content={window.location.href} />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content={companyDetail.about_us_meta_title} />
                <link rel="canonical" href={`${window.location.origin}/About`} />
            </Helmet>

            <section className="breadscrumb-section pt-0">
                <div className="container-fluid-lg">
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="breadscrumb-contain">
                                <h2>About Us</h2>
                                <nav>
                                    <ol className="breadcrumb mb-0">
                                        <li className="breadcrumb-item">
                                            <Link to="/">
                                                <i className="fa-solid fa-house" />
                                            </Link>
                                        </li>
                                        <li className="breadcrumb-item active" aria-current="page">
                                            About Us
                                        </li>
                                    </ol>
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/*about */}
            <section className="fresh-vegetable-section section-lg-space">
                <div className="container-fluid-lg">

                    <div className="row gx-xl-5 gy-xl-0 g-3 ratio_148_1  bg-white p-3">
                        <div className="about-us-title">
                            <h2>{companyDetail.company_about_heading}</h2>
                        </div>

                        <div dangerouslySetInnerHTML={{ __html: companyDetail.company_about_detail }} className='editor inter-font'></div>

                        {/* <div className="col-xl-8 col-sm-12">
                            <div className="fresh-contain p-center-left">
                                <div>
                                   
                                    <div className="delivery-list">
                                        <p className="text-content">
                                            At Valorelle, we believe fragrance is more than scent—it's a statement. A whisper of identity. A quiet act of power. We create affordable luxury perfumes designed for self-expression, crafted for all, and priced so that no one has to wait for a special occasion to feel extraordinary.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-4 col-sm-12">
                            <img
                                style={{ height: "30vh", width: "100%" }}
                                src="../assets/images/perfume/per2.jpeg"
                                className="bg-img lazyloaded"
                                alt=""
                            />
                        </div>
                        <div className="col-xl-12 col-sm-12">
                            <div className="fresh-contain p-center-left">
                                <div>
                                    <div className="about-us-title">
                                        <h3 className='inter-font text-theme'><i className='fa fa-check-double me-2' />Reimagining Scent, Beyond Binaries</h3>

                                    </div>
                                    <div className="delivery-list">
                                        <p className="text-content">
                                            At Valorelle, we believe fragrance is more than scent—it's a statement. A whisper of identity. A quiet act of power. We create affordable luxury perfumes designed for self-expression, crafted for all, and priced so that no one has to wait for a special occasion to feel extraordinary.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-xl-12 col-sm-12">
                            <div className="fresh-contain p-center-left">
                                <div>
                                    <div className="about-us-title">
                                        <h3 className='inter-font text-theme'><i className='fa fa-check-double' /> Made to Last. Made to Empower.</h3>
                                    </div>
                                    <div className="delivery-list">
                                        <p className="text-content">
                                            Every bottle of Valorelle is thoughtfully formulated for long-lasting performance and bold projection, so your presence lingers—elegantly. We source quality ingredients and use high-concentration blends to create scents that defy their price tag. Because luxury shouldn’t be rare, and you shouldn’t have to settle.</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-xl-12 col-sm-12">
                            <div className="fresh-contain p-center-left">
                                <div>
                                    <div className="about-us-title">
                                        <h3 className='inter-font text-theme'><i className='fa fa-check-double' />Beautifully Packaged. Honestly Priced</h3>
                                    </div>
                                    <div className="delivery-list">
                                        <p className="text-content">
                                            Valorelle perfumes come housed in elegant, minimalist bottles that look as good as they smell. At just around ₹1000, our fragrances offer the look, feel, and performance of designer scents—without the markup. We invest in what matters: formula, design, and you.</p>
                                    </div>
                                </div>
                            </div>
                        </div> */}
                        <img
                            style={{ width: "100%" }}
                            src="../assets/images/perfume/per2.jpeg"
                            className="bg-img lazyloaded"
                            alt=""
                        />
                    </div>
                </div>
            </section>


        </>
    )
}

export default About;